import ProductImageGalleryModal from '../components/ProductImageGalleryModal.svelte'

let target = document.getElementById('gallery-modal')

const app = new ProductImageGalleryModal({
  target,
  props: {
    
  },
})

class ProductMedia extends HTMLElement {
  mainImage: any
  images: any
  currentImage: any
  productImages: any
  selectedImage: any

  constructor() {
    super()

    let images = []

    this.productImages = this.querySelectorAll('.product-gallery__image')

    this.mainImage = this.querySelector('.product-gallery__main-image');

    this.mainImage?.parentElement?.addEventListener('click', (e) => {
      e.preventDefault()

      window.openImageModal && window.openImageModal(this.currentImage);
    })

    for (let productImage of this.productImages) {
      const image = productImage.querySelector('img');
      const imageObj = {
        id: productImage.dataset.id,
        url: productImage.dataset.previewUrl,
        variantId: productImage.dataset.variantId,
        height: productImage.dataset.height,
        width: productImage.dataset.width,
        alt: productImage.dataset.alt,
        image: image,
      };

      images.push(imageObj);

      if (productImage.getAttribute('aria-selected') === 'true') {
        this.selectedImage = imageObj;
        this.currentImage = imageObj;
      };

      productImage.addEventListener('mouseenter', (e) => {        
        this.showImage(imageObj, false);
      })
      productImage.addEventListener('click', function (e) {
        e.preventDefault()
        
        window.openImageModal && window.openImageModal(imageObj);
      })

      app.$set({ images });

      this.images = images;

      if (!this.selectedImage) this.selectedImage = images[0];
    }

    this.selectImage = this.selectImage.bind(this)
  }

  showImage (imageObj, scroll = true) {
    const image = imageObj.image;

    this.mainImage?.setAttribute('src', image?.getAttribute('src') || '')
    this.mainImage?.setAttribute('alt', image?.getAttribute('alt') || '')
    this.mainImage?.setAttribute('srcset', image?.getAttribute('srcset') || '')

    this.productImages.forEach((productImage) => productImage.setAttribute('aria-selected', 'false'));
    image.parentElement.setAttribute('aria-selected', 'true');

    this.currentImage = imageObj;

    if (scroll) {
      let container = image.parentElement?.parentElement;
      container.scrollLeft = image.parentElement.offsetLeft - container.offsetWidth / 2 + image.parentElement.offsetWidth / 2;
    }
  }

  selectImage(variantId) {
    let image = this.images.find((image) => (image.variantId?.split(',').indexOf(variantId + '') !== -1));
    console.log(image, variantId)

    if (!image) return;

    this.selectedImage = image;

    this.showImage(image);
  }
}

customElements.define('product-media', ProductMedia);